import { ReactNode } from 'react';

import { useFlag, useFlagsStatus } from '@unleash/proxy-client-react';
import { FeatureToggle } from 'utils/unleash/toggles';

import LoadingPage from 'pages/LoadingPage';

export const flagsSync = {
  [FeatureToggle.NewLoginFlow]: undefined as unknown as boolean,
};

export function ReadFlagsSync({ children }: { children: ReactNode }) {
  const { flagsReady, flagsError } = useFlagsStatus();
  const newLoginFlow = useFlag(FeatureToggle.NewLoginFlow);

  if (flagsError) {
    return children as JSX.Element;
  }

  if (!flagsReady) {
    return <LoadingPage />;
  }

  flagsSync[FeatureToggle.NewLoginFlow] =
    flagsSync[FeatureToggle.NewLoginFlow] ?? newLoginFlow;

  return children as JSX.Element;
}
